import Template from '../templates/Template';
import React  from 'react';
import DashboardDemo from '../components/DashboardDemo';

const Home = (props) => {

    console.log("Home.js");

    

    return (
       
        <Template>
        </Template>

    );

}

export default Home;
